'use client'

import Link from 'next/link'
import { H1 } from '@/General/H1'
import { ContentWrapper } from '@/General/ContentWrapper'
import { MasterclassButton } from '@/MasterclassButton'
import { useSubscriptionEligibility } from '@/useSubscriptionEligibility'
import { useStorefrontDisplayCurrency } from '@/useStorefrontDisplayCurrency'

const MasterclassPricingText = () => {
  const {
    isSubscriber,
    hasHadSubscriptionBefore,
    isEligibleForTrial,
    isLoading,
  } = useSubscriptionEligibility()
  const { currencySymbol } = useStorefrontDisplayCurrency()

  if (isSubscriber || isLoading) {
    return null
  }

  return (
    <p className="text-vi-gray mt-2 text-sm">
      {hasHadSubscriptionBefore && !isEligibleForTrial
        ? `Monthly subscription is ${currencySymbol}50.00 and automatically renews each month until cancelled.`
        : `After your trial, the monthly subscription is ${currencySymbol}50.00 and automatically renews each month until cancelled.`}
    </p>
  )
}

export const InspiredSection = () => {
  return (
    <section id="inspired">
      <ContentWrapper>
        <div className="flex flex-wrap">
          <div className="w-full lg:w-8/12 mb-4 text-xl pr-4">
            <H1 className="text-2xl md:text-4xl">
              Want to be a better magician?
            </H1>

            <p className="mb-2 text-2xl">
              Find the inspiration needed to reach the next level with exclusive
              lectures and interviews!
            </p>

            <p className="mb-2">
              Subscribe to Vanishing Inc. Masterclass and discover why it's the
              best value in magic:
            </p>

            <ul className="list-disc pl-5 mb-2">
              <li>New, world-class lectures every month</li>
              <li>Special Q&amp;A with the monthly lecturer</li>
              <li>
                Massive streaming catalogue of past Masterclass lectures (400+
                hours)
              </li>
              <li>
                New bestselling tricks added to the{' '}
                <Link
                  href="/masterclass/studio/"
                  className="text-vi-red hover:underline"
                >
                  VI Studio
                </Link>{' '}
                video library every month
              </li>
              <li>
                Masterclass Moments: a series featuring deep dives on exciting
                topics
              </li>
              <li>
                Exclusive interview series featuring deep dives on exciting
                topics
              </li>
            </ul>

            <p className="mb-2">
              Groundbreaking new tricks. Revolutionary magic theory. One
              unbeatable price!
            </p>

            <p className="mb-2">
              Join the Vanishing Inc. Masterclass community and take the next
              step in becoming the best magician you can be!
            </p>
            <MasterclassButton className="mt-2 bg-vi-red text-white px-6 py-3 rounded-md font-semibold hover:bg-vi-red-dark transition-colors" />
            <MasterclassPricingText />
          </div>
          <div className="w-full lg:w-4/12">
            <div className="relative w-full aspect-[9/16]">
              <iframe
                src="https://iframe.mediadelivery.net/embed/113993/753fce6a-aeda-4708-afb6-4d2bf01b3e4f?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                className="absolute top-0 left-0 w-full h-full border-0"
                loading="lazy"
                title="Masterclass video"
              ></iframe>
            </div>
          </div>
        </div>
      </ContentWrapper>
    </section>
  )
}
